const ileggelser = {
  shortUrl: "/ileggelser",
  oversikt: {
    shortUrl: "/ileggelser/oversikt",
    utskrift: "/ileggelser/oversikt/utskrift",
    detalj: {
      route: "/ileggelser/oversikt/:id",
      getUrl: (ileggelseId) => `/ileggelser/oversikt/${ileggelseId}`,
      rediger: "/ileggelser/oversikt/:id/bilder/:bildeId/rediger",
      bilde: "/ileggelser/oversikt/:id/bilder/:bildeId",
      svarUtHistorikk: "/ileggelser/oversikt/:id/svar-ut/:svarUtId/historikk",
    },
  },
  ettersendelser: {
    shortUrl: "/ileggelser/ettersendelser",
    utskrift: "/ileggelser/ettersendelser/utskrift",
    detalj: {
      route: "/ileggelser/ettersendelser/:id",
      getUrl: (ileggelseId) => `/ileggelser/ettersendelser/${ileggelseId}`,
      utskrift: "/ileggelser/ettersendelser/:id/utskrift",
      rediger: "/ileggelser/ettersendelser/:id/bilder/:bildeId/rediger",
      bilde: "/ileggelser/ettersendelser/:id/bilder/:bildeId",
      svarUtHistorikk:
        "/ileggelser/ettersendelser/:id/svar-ut/:svarUtId/historikk",
    },
  },
  ettersendelserTilGodkjenning: {
    shortUrl: "/ileggelser/ettersendelser-til-godkjenning",
    detalj: {
      route: "/ileggelser/ettersendelser-til-godkjenning/:id",
      getUrl: (ileggelseId) =>
        `/ileggelser/ettersendelser-til-godkjenning/${ileggelseId}`,
      utskrift: "/ileggelser/ettersendelser-til-godkjenning/:id/utskrift",
      rediger:
        "/ileggelser/ettersendelser-til-godkjenning/:id/bilder/:bildeId/rediger",
      bilde:
        "/ileggelser/ettersendelser-til-godkjenning/:id/bilder/:bildeId/bilde",
      svarUtHistorikk:
        "/ileggelser/ettersendelser-til-godkjenning/:id/svar-ut/:svarUtId/historikk",
    },
  },
  elsparksykkelGebyr: {
    shortUrl: "/ileggelser/elsparksykkel-gebyr",
    utskrift: "/ileggelser/elsparksykkel-gebyr/utskrift",
    detalj: {
      route: "/ileggelser/elsparksykkel-gebyr/:id",
      getUrl: (ileggelseId) => `/ileggelser/elsparksykkel-gebyr/${ileggelseId}`,
      utskrift: "/ileggelser/elsparksykkel-gebyr/:id/utskrift",
      rediger: "/ileggelser/elsparksykkel-gebyr/:id/bilder/:bildeId/rediger",
      bilde: "/ileggelser/elsparksykkel-gebyr/:id/bilder/:bildeId",
      svarUtHistorikk:
        "/ileggelser/elsparksykkel-gebyr/:id/svar-ut/:svarUtId/historikk",
    },
  },
};

export default ileggelser;
